import { useState, useEffect } from 'react';
import { useAtom } from 'jotai';

// Our components
import SearchInput from 'components/Input/SearchInput';

// Our Hooks
import useDebounce from 'hooks/useDebounce';

// Our Atoms
import searchQueryAtom from 'state/atoms/paginationSearchAtom';

function SearchClients({ debounceCallBack, sx, disable }) {
	// Cached offline query
	const [searchQuery] = useAtom(searchQueryAtom);

	const [searchData, setSearchData] = useState(searchQuery);

	const debouncedSearchResult = useDebounce(searchData, 500);

	useEffect(() => {
		debounceCallBack(debouncedSearchResult);
	}, [debouncedSearchResult]);

	return (
		<SearchInput
			disable={disable}
			autoComplete="off"
			value={searchData}
			onChange={(e) => setSearchData(e.target.value)}
			placeholder="Client Name"
		/>
	);
}

export default SearchClients;
